import { ModelBase, NeoModel, Rules } from "@singularsystems/neo-core";

@NeoModel
export default class InstrumentSubTypeLookup extends ModelBase {
    
    public staticInstrumentSubTypeId: number = 0;

    public staticInstrumentTypeId: number = 0;

    @Rules.Required()
    @Rules.StringLength(100)
    public instrumentSubTypeName: string = "";
}